import { ListNames } from '@acorn-portal/shared/src/store/referenceData.slice';
import { useAppSelector } from './reduxHook';

const useReferenceData = () => {
	const lists = useAppSelector((redux) => redux.referenceData);
	const getReferenceDataValue = (listName: ListNames, value: string): string => {
		const option = lists[listName].find((x) => x.value === value);

		if (option) {
			return option.label as string;
		}
		return value;
	};
	return { lists, getReferenceDataValue };
};

export default useReferenceData;
